import React, { Component } from "react";
import axios from "axios";
import { Button, Form, Grid, TextArea, Input } from 'semantic-ui-react'
import { NumberLiteral } from "@babel/types";

const url = "https://encontech.azurewebsites.net/api/jobs";
const uploadUrl = 'https://encontech.azurewebsites.net/api/file';

//const url = "http://localhost:5000/api/jobs";
//const uploadUrl = 'http://localhost:5000/api/file';

type JobState =
{
  name : string,
  link: string,
  address: string,
  brand: string,
  version: string,
  contractStartDate: string,
  contractEndDate: string,
  comments: string
};

class AdminAddJob extends React.Component<{}, JobState> {
  constructor(props: any) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      name :"",
      link: "",
      address: "",
      brand: "",
      version: "",
      contractStartDate: "",
      contractEndDate: "",
      comments: ""
    };

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleLinkChange = this.handleLinkChange.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleContractStartDateChange = this.handleContractStartDateChange.bind(this);
    this.handleContractEndDateChange = this.handleContractEndDateChange.bind(this);
    this.handleCommentsChange = this.handleCommentsChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  fileInput : any;
  
  handleNameChange(e:any) {
    this.setState({ name: e.target.value });
  }
  handleLinkChange(e:any) {
    this.setState({ link: e.target.value });
  }
  handleAddressChange(e:any) {
    this.setState({ address: e.target.value });
  }
  handleBrandChange(e:any) {
    this.setState({ brand: e.target.value });
  }
  handleVersionChange(e:any) {
    this.setState({ version: e.target.value });
  }
  handleContractStartDateChange(e:any) {
    this.setState({ contractStartDate: e.target.value });
  }
  handleContractEndDateChange(e:any) {
    this.setState({ contractEndDate: e.target.value});
  }
  handleCommentsChange(e:any) {
    this.setState({ comments: e.target.value });
  }

  handleSubmit(e: any ) {
    console.log(this.state.name);
    console.log(this.state.link);
    console.log(this.state.address);
    console.log(this.state.brand);
    console.log(this.state.version);
    console.log(true);
    console.log(this.state.contractStartDate);
    console.log(this.state.contractEndDate);
    console.log(this.state.comments);

    const formData = new FormData();
    formData.append("files", this.fileInput.current.files[0]);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    axios
      .post(uploadUrl, formData, config)
      .then((response) => {
        console.log(response.data);
        var af = { fileGuid: response.data.guid, fileName: response.data.file };
        axios
          .post(url, {
            name: this.state.name,
            link: this.state.link,
            address: this.state.address,
            brand: this.state.brand,
            version: this.state.version,
            contract: true,
            contractStartDate: this.state.contractStartDate,
            contractEndDate: this.state.contractEndDate,
            contractExpirationDate: this.state.contractEndDate,
            alarmFormFile: af,
            comments: this.state.comments,
          })
          .then((res) => {
            this.setState({
              name: "",
              link: "",
              address: "",
              brand: "",
              version: "",
              contractStartDate: "",
              contractEndDate: "",
              comments: "",
            });

            this.fileInput.current.value = "";
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });  
    e.preventDefault();  
  }

  render() {
    return (
    <div style={{ height:"500px" }}>
        <h1>Admin (Add Job Site)</h1>
        <Form onSubmit={this.handleSubmit}>
    <Grid columns={2} divided padded>
        <Grid.Row>
            <Grid.Column>
                <Form.Field>
                <label>Name</label>
                <input type="text" value={this.state.name} onChange={this.handleNameChange} />
                </Form.Field>
                <Form.Field>
                <label>Link</label>
                <Input type="text" value={this.state.link} onChange={this.handleLinkChange}/>
            </Form.Field>
            <Form.Field>
                <label>Address</label>
                <input type="text" value={this.state.address} onChange={this.handleAddressChange} />
            </Form.Field>
            <Form.Field>
                <label>Brand</label>
                <input  type="text" value={this.state.brand} onChange={this.handleBrandChange}/>
            </Form.Field>
            <Form.Field>
                <label>Version</label>
                <input  type="text" value={this.state.version} onChange={this.handleVersionChange}/>
            </Form.Field>
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
        <label>Contract Start Date</label>
        <input type="date" value={this.state.contractStartDate} onChange={this.handleContractStartDateChange}/>
      </Form.Field>
      <Form.Field>
        <label>Contract End Date</label>
        <input type="date"  value={this.state.contractEndDate} onChange={this.handleContractEndDateChange}/>
      </Form.Field>
      <Form.Field>
        <label>Comments</label>
        <TextArea placeholder='Additional Information' style={{ minHeight: 110 }} type="text" value={this.state.comments} onChange={this.handleCommentsChange}/>
      </Form.Field>
      <Form.Field>
        <label>Alarm Form</label>
        <input type="file" ref={this.fileInput} />
      </Form.Field>
            </Grid.Column>
        </Grid.Row>
    </Grid>
    <Button type='submit' value="Submit" onClick={this.handleSubmit.bind(this)} primary>Submit</Button>

    </Form>
    </div>
  )}}
  
  export default AdminAddJob